import { useTranslation } from "react-i18next";
import { OptionButtons } from "components/Form/OptionButtons";

export const ASSESSMENT_SUBJECT_SELF = 1;
export const ASSESSMENT_SUBJECT_OTHERS = 2;

export function AsscessmentTarget({
  onAnswer,
  defaultOption = null,
  className = '',
}) {
  const { t } = useTranslation();
  return (
    <div className={className}>
      <p>{ t('who is this assessment for') }</p>
      <OptionButtons
        className="options"
        defaultOption={defaultOption}
        options={[
          { label: t("myself"), value: ASSESSMENT_SUBJECT_SELF },
          { label: t("others"), value: ASSESSMENT_SUBJECT_OTHERS },
        ]}
        onSelect={(value) => onAnswer(value)}
      />
    </div>
  );
}

/**
 * Get the human readable subject name
 *
 * @param {number} assessmentSubject
 * @returns {string}
 */
export function getSubjectName(assessmentSubject) {
  switch (assessmentSubject) {
    case ASSESSMENT_SUBJECT_SELF:
      return 'for myself';
    case ASSESSMENT_SUBJECT_OTHERS:
      return 'for others';
    default:
      return '';
  }
}

export default AsscessmentTarget;